module.exports = __webpack_public_path__ + "static/media/artist-rush-album-7.53b03519.jpg";